import type { VolumeProfileChartBar, VolumeProfileLevel } from './state/types';

export const VOLUME_PROFILE_CURRENT_PRICE = 207.48;
export const VOLUME_PROFILE_VWAP = 206.72;

export const VOLUME_PROFILE_LEVELS: readonly VolumeProfileLevel[] = Object.freeze([
    {
        id: '209-50',
        price: 209.5,
        bid: 610_000,
        mid: 170_000,
        ask: 760_000,
        premarket: 80_000,
        regular: 1_360_000,
        postmarket: 100_000,
    },
    {
        id: '209-00',
        price: 209,
        bid: 820_000,
        mid: 210_000,
        ask: 980_000,
        premarket: 120_000,
        regular: 1_720_000,
        postmarket: 170_000,
    },
    {
        id: '208-50',
        price: 208.5,
        bid: 1_180_000,
        mid: 320_000,
        ask: 1_420_000,
        premarket: 190_000,
        regular: 2_480_000,
        postmarket: 250_000,
    },
    {
        id: '208-00',
        price: 208,
        bid: 1_780_000,
        mid: 540_000,
        ask: 1_910_000,
        premarket: 280_000,
        regular: 3_520_000,
        postmarket: 430_000,
    },
    {
        id: '207-50',
        price: 207.5,
        bid: 2_460_000,
        mid: 720_000,
        ask: 2_660_000,
        premarket: 440_000,
        regular: 4_840_000,
        postmarket: 560_000,
    },
    {
        id: '207-00',
        price: 207,
        bid: 2_120_000,
        mid: 650_000,
        ask: 2_280_000,
        premarket: 360_000,
        regular: 4_220_000,
        postmarket: 470_000,
    },
    {
        id: '206-50',
        price: 206.5,
        bid: 1_640_000,
        mid: 520_000,
        ask: 1_740_000,
        premarket: 280_000,
        regular: 3_260_000,
        postmarket: 360_000,
    },
    {
        id: '206-00',
        price: 206,
        bid: 1_120_000,
        mid: 360_000,
        ask: 1_200_000,
        premarket: 190_000,
        regular: 2_240_000,
        postmarket: 250_000,
    },
    {
        id: '205-50',
        price: 205.5,
        bid: 780_000,
        mid: 230_000,
        ask: 830_000,
        premarket: 140_000,
        regular: 1_560_000,
        postmarket: 140_000,
    },
    {
        id: '205-00',
        price: 205,
        bid: 520_000,
        mid: 160_000,
        ask: 560_000,
        premarket: 80_000,
        regular: 1_060_000,
        postmarket: 100_000,
    },
]);

export const VOLUME_PROFILE_CHART_BARS: readonly VolumeProfileChartBar[] = Object.freeze([
    { id: '09:30', label: '9:30a', topPct: 64, bodyTopPct: 61, bodyHeightPct: 9, volumePct: 28, direction: 'up' },
    { id: '10:00', label: '10a', topPct: 58, bodyTopPct: 54, bodyHeightPct: 11, volumePct: 42, direction: 'up' },
    { id: '10:30', label: '10:30a', topPct: 48, bodyTopPct: 47, bodyHeightPct: 8, volumePct: 38, direction: 'down' },
    { id: '11:00', label: '11a', topPct: 43, bodyTopPct: 40, bodyHeightPct: 12, volumePct: 55, direction: 'up' },
    { id: '11:30', label: '11:30a', topPct: 36, bodyTopPct: 35, bodyHeightPct: 10, volumePct: 64, direction: 'up' },
    { id: '12:00', label: '12p', topPct: 32, bodyTopPct: 31, bodyHeightPct: 8, volumePct: 45, direction: 'down' },
    { id: '12:30', label: '12:30p', topPct: 28, bodyTopPct: 27, bodyHeightPct: 10, volumePct: 59, direction: 'up' },
    { id: '13:00', label: '1p', topPct: 25, bodyTopPct: 23, bodyHeightPct: 11, volumePct: 71, direction: 'up' },
    { id: '13:30', label: '1:30p', topPct: 21, bodyTopPct: 23, bodyHeightPct: 9, volumePct: 48, direction: 'down' },
    { id: '14:00', label: '2p', topPct: 18, bodyTopPct: 16, bodyHeightPct: 10, volumePct: 52, direction: 'up' },
    { id: '14:30', label: '2:30p', topPct: 16, bodyTopPct: 18, bodyHeightPct: 8, volumePct: 36, direction: 'down' },
    { id: '15:00', label: '3p', topPct: 12, bodyTopPct: 11, bodyHeightPct: 11, volumePct: 67, direction: 'up' },
]);
